import { render, staticRenderFns } from "./sider-right.vue?vue&type=template&id=0d64efb5&scoped=true"
import script from "./sider-right.vue?vue&type=script&lang=js"
export * from "./sider-right.vue?vue&type=script&lang=js"
import style0 from "./sider-right.vue?vue&type=style&index=0&id=0d64efb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d64efb5",
  null
  
)

export default component.exports